<template>
	<div>
        <div class="font-semibold text-2xl">
            £{{ price }}
        </div>

        <product-option v-model="form.options[index]"
                        :option="option"
                        v-for="(option, index) in options"
                        :key="option.id"
                        class="mt-4"
                        v-if="! shouldBeHidden(option)"
        ></product-option>

        <form-quantity v-model="form.quantity"
                       label="Quantity"
                       :bold="true"
                       class="mt-4 max-w-xxxxs"
        ></form-quantity>

        <form-button class="mt-4"
                     @click.native="addToBasket"
        >
            Add to Basket
        </form-button>
    </div>
</template>

<script>
    import ProductOption from "./ProductOption";
    import FormButton from "../../form/public/Button";
    import FormQuantity from "../../form/Quantity";

	export default {
	    data() {
	        return {
	            form: {
	                product_id: this.product.id,
	                quantity: 1,
                    options: {}
                }
            }
        },

        props: {
            product: {
                type: Object,
                required: true,
            },

            basePrice: {
                type: String,
                required: true,
            },

            options: {
                type: Array,
                required: true,
            },
        },

        components: { ProductOption, FormButton, FormQuantity },

        created() {
	        this.initialiseFormData()
        },

        computed: {
            price() {
                let basePrice = parseFloat(this.basePrice.replace(',', ''));

                return (basePrice + this.optionsTotal)
                    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },

            optionsTotal() {
                let total = 0;

                _.forEach(this.form.options, selectedOption => {
                    let option = _.find(this.options, ['id', selectedOption.option_id]);
                    let value = _.find(option.values, ['id', selectedOption.value]);

                    total += parseFloat(value.formatted_price);
                });

                return total;
            }
        },

        methods: {
            initialiseFormData() {
                _.forEach(this.options, (option, index) => {
                    this.$set(this.form.options, index, {
                        option_id: option.id,
                        name: option.name,
                        value: _.first(option.values).id,
                    })
                });
            },

            addToBasket() {
                axios.post('/basket/product', this.form)
                    .then(response => {
                        bus.$emit('update-basket-count');
                        createToast('Product added to basket!', `The ${this.product.name} was added to the basket.`);
                    })
                    .catch(error => {

                    });
            },

            shouldBeHidden(option) {
                if (this.product.type !== 'voucher' || option.system_id !== 'amount') {
                    return false;
                }

                return option.values.length <= 1;
            }
        }
	}
</script>
